module.exports = __webpack_public_path__ + "img/icon-resources.2f433760.svg";